import { useMemo } from "react";

import User from "@mapmycustomers/shared/types/User";

const useUserIds = (selectedUsers: User[]): Array<User["id"]> =>
  useMemo(() => selectedUsers.map(({ id }) => id), [selectedUsers]);

export default useUserIds;
